import type { FC, ReactNode } from 'react'

import { ARC } from '@/components/generals/arcade'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PixelScreen, ScreenPrompt } from '@/components/generals/pixel-screen'
import Achievements from '@/components/landing/about/achievements'
import Continue from '@/components/landing/about/continue'
import HouseRules from '@/components/landing/about/house-rules'
import Profile from '@/components/landing/about/profile'
import { ABOUT } from '@/components/landing/about/data'
import { RESUME } from '@/components/landing/cabinet/data'

const About: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='About' description={ABOUT.meta} />

            <div className={ARC.page}>
                <div className={ARC.wrap}>
                    <PixelScreen
                        caption="Player 1"
                        word="About"
                        subcaption={RESUME.name}
                        heading={`About ${RESUME.name}`}
                    >
                        <ScreenPrompt target='profile' action="to read on" />
                    </PixelScreen>

                    <Profile />
                    <HouseRules />
                    <Achievements />
                    <Continue />
                </div>
            </div>
        </Layout>
    )
}

export default About
